(function() {
  define('tlh/copyToClipboard',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('tlhComponentsCopyToClipboard', ['ngAnimate', 'ui.bootstrap']).component('tlhCopyToClipboard', {
      template: '<a href="" ng-click="$ctrl.copyToClipboard()" uib-tooltip="{{$ctrl.tooltip}}" ng-transclude></span>',
      transclude: true,
      bindings: {
        value: '@',
        tooltip: '@?',
        clickedTooltip: '@?'
      },
      controller: [
        '$window', '$timeout', function($window, $timeout) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            if (vm.tooltip == null) {
              vm.tooltip = 'Copier';
            }
            vm.initTooltip = vm.tooltip;
            return vm.clickedTooltip != null ? vm.clickedTooltip : vm.clickedTooltip = 'Copié !';
          };
          vm.copyToClipboard = function() {
            var body, err, successful, textarea;
            body = angular.element($window.document.body);
            textarea = angular.element('<textarea/>');
            textarea.css({
              position: 'fixed',
              opacity: '0'
            });
            textarea.val(vm.value);
            body.append(textarea);
            textarea[0].select();
            document.execCommand('copy');
            try {
              successful = document.execCommand('copy');
              if (!successful) {
                throw successful;
              }
              vm.tooltip = vm.clickedTooltip;
              return $timeout(function() {
                return vm.tooltip = vm.initTooltip;
              }, 2000);
            } catch (_error) {
              err = _error;
              window.prompt("Copier: Ctrl+C", vm.value);
              return console.error(err);
            }
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=copyToClipboard.js.map
;
